import Vue from 'vue'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    xs: 450,
    sm: 768,
    md: 1024,
    lg: 1200,
    xlg: Infinity
  }
})

export default VueMq
